var _require = require('react'),
  createContext = _require.createContext;
var _require2 = require('react-redux'),
  OriginalReactReduxContext = _require2.ReactReduxContext;
var isLegacyReactRedux = !OriginalReactReduxContext;
var ReactReduxContext = OriginalReactReduxContext || createContext(null);
module.exports = {
  isLegacyReactRedux: isLegacyReactRedux,
  ReactReduxContext: ReactReduxContext
};